import { FormGroup } from '@angular/forms';

/**
 * Convention used across every form in the app: the wrapper element around a
 * field is given `id="field-<controlName>"` so this utility can find it
 * without depending on formControlName being reflected as a DOM attribute
 * (it isn't, when bound via property binding).
 */
export function fieldElementId(controlName: string): string {
  return `field-${controlName}`
}

export function focusAndScrollToField(container: HTMLElement | null, controlName: string): void {
  if (!container) return
  const el = container.querySelector<HTMLElement>(`#${CSS.escape(fieldElementId(controlName))}`)
  if (!el) return
  el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  const focusable = el.querySelector<HTMLElement>('input, textarea, select, .ck-editor__editable, button')
  focusable?.focus()
}

export interface FieldError {
  key: string
  label: string
}

/**
 * Builds the ordered list of currently-invalid fields, given the ordered
 * list of {key, label} pairs the form considers required/checked.
 */
export function collectFieldErrors(form: FormGroup, fields: FieldError[]): FieldError[] {
  return fields.filter(f => form.get(f.key)?.invalid)
}
